<template>
  <div class="available-vaccines" :style="css">
    <Loading v-if="loading" />

    <v-container v-else class="py-10 py-sm-12 py-md-14 py-lg-16">
      <PagesTitle :mod="mod">Vacinas disponíveis</PagesTitle>
      <v-row justify="center" class="mt-md-16 mt-5 pb-4">
        <v-col sm="10" md="12">
          <v-expansion-panels flat accordion>
            <v-row justify="start">
              <v-col
                v-for="({ title, text }, i) in items"
                :key="i"
                cols="12"
                sm="6"
                md="4"
                class="px-4"
              >
                <v-expansion-panel :disabled="text ? false : true">
                  <v-expansion-panel-header disable-icon-rotate
                    ><span class="font-weight-bold grey--text text--darken-1">
                      {{ title }}
                    </span>
                    <template v-slot:actions>
                      <v-icon size="26" color="page-color-primary"
                        >fas fa-check-square</v-icon
                      >
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <span
                      class="text-caption grey--text text--darken-1"
                      v-html="text"
                    ></span>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-col>
            </v-row>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PagesTitle from "../widgets/PagesTitle.vue";
import Loading from "../widgets/Loading.vue";

const _config = {
  mod: "pages-available",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    loading: true,
    items: [],
  }),
  mounted() {
    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => (this.items = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    css() {
      return {
        "--page-color": this.color,
      };
    },
  },
  components: {
    Loading,
    PagesTitle,
  },
};
</script>

<style lang="scss" scoped>
.available-vaccines
  ::v-deep
  .v-expansion-panel--disabled
  .v-expansion-panel-header__icon {
  display: block !important;
}

.page-color-primary {
  background-color: var(--page-color) !important;
}
.page-color-primary--text {
  color: var(--page-color) !important;
}
.v-expansion-panel {
  border: 1px solid #d9d9d9 !important;
  border-radius: 4px !important;
  padding-top: 2px;
  padding-bottom: 2px;
  &::before {
    box-shadow: none !important;
  }
}
</style>
